import { z } from 'zod'

export const STRATALYST_COMPANY_PROJECT_CONTRACT_VERSION = '1.0.0' as const

const passthroughResponseSchema = z.unknown()

export const stratalystCompanyListResponseSchema = passthroughResponseSchema
export const stratalystCompanyCreateResponseSchema = passthroughResponseSchema
export const stratalystCompanyOverviewResponseSchema = passthroughResponseSchema
export const stratalystProjectListResponseSchema = passthroughResponseSchema
export const stratalystProjectCreateResponseSchema = passthroughResponseSchema
export const stratalystProjectUpdateResponseSchema = passthroughResponseSchema
export const stratalystProjectOverviewResponseSchema = passthroughResponseSchema

export type StratalystCompanyListResponse = z.infer<typeof stratalystCompanyListResponseSchema>
export type StratalystCompanyCreateResponse = z.infer<typeof stratalystCompanyCreateResponseSchema>
export type StratalystCompanyOverviewResponse = z.infer<typeof stratalystCompanyOverviewResponseSchema>
export type StratalystProjectListResponse = z.infer<typeof stratalystProjectListResponseSchema>
export type StratalystProjectCreateResponse = z.infer<typeof stratalystProjectCreateResponseSchema>
export type StratalystProjectUpdateResponse = z.infer<typeof stratalystProjectUpdateResponseSchema>
export type StratalystProjectOverviewResponse = z.infer<typeof stratalystProjectOverviewResponseSchema>
